// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"78806597","418":"22ac7673","424":"6acd8d0a","453":"700e848e","517":"0e7c6699","561":"a41f5e8f","699":"9fe32ed7","736":"279ef923","823":"b6fa086d","931":"ce42d940"}[chunkId] + ".chunk.js";
};